export default __webpack_public_path__ + "static/media/history-clock-button-grey.91d70814.svg";